import { Flex, FlexProps, Radio } from "@chakra-ui/react";
import { FormattedMessage } from "react-intl";

import { AuthMode } from "@nens/ldo/api-v1";

interface ModeTogglerProps extends FlexProps {
  authMode: AuthMode;
  setAuthMode: (authMode: AuthMode) => void;
}

export function ModeToggler({
  authMode,
  setAuthMode,
  flexDirection = "column",
  ...rest
}: ModeTogglerProps) {
  return (
    <Flex flexDirection={flexDirection} {...rest}>
      <Flex justifyContent="space-between" alignItems="center" fontWeight="normal">
        <Radio
          size="md"
          onChange={(e) => e.target.checked && authMode !== "public" && setAuthMode("public")}
          isChecked={authMode === "public"}
        >
          <FormattedMessage id="filtertree.public" defaultMessage="Publicly visible" />
        </Radio>
      </Flex>
      <Flex justifyContent="space-between" alignItems="center" fontWeight="normal">
        <Radio
          size="md"
          onChange={(e) => e.target.checked && authMode !== "private" && setAuthMode("private")}
          isChecked={authMode === "private"}
        >
          <FormattedMessage id="filtertree.private" defaultMessage="Your organisation" />
        </Radio>
      </Flex>
    </Flex>
  );
}
